import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('camere');
export const actions = helper.createActions('camere', actionTypes);
